// Angular Imports
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
// This Module Imports
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
// Angular Material Imports
import { MatDialogModule } from '@angular/material/dialog'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
// Shared Imports
import { EnvironmentDecoratorComponent } from '@shared/components'
import { AddTokenAndRefreshInterceptor } from '@shared/interceptors'

const sharedComponents = [EnvironmentDecoratorComponent]

const material = [MatDialogModule]

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		HttpClientModule,
		...sharedComponents,
		...material,
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AddTokenAndRefreshInterceptor,
			multi: true,
		},
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: { hideRequiredMarker: true },
		},
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
